export const userConsumptionHistoryColumns = [
  { label: 'Transação', value: 'protocol_number' },
  { label: 'Fatura', value: 'bill' },
  { label: 'Tipo', value: 'type' },
  { label: 'Detalhes', value: 'details' },
  { label: 'Vlr. Total', value: 'total_amount' },
  { label: 'Tarifas', value: 'fee_total' },
  { label: 'Ret. IR.', value: 'income_tax_total_amount' },
  { label: 'Filial', value: 'client_branch_name' },
  { label: 'Cartão', value: 'card' },
  { label: 'Km Informado', value: 'current_equipment_usage' },
  { label: 'Autor', value: 'author' },
  { label: 'Data e hora', value: 'created_at' },
]
